import { Injectable } from '@angular/core';
import { DataService } from '../shared/services/data.service';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class FinanceiroService extends DataService {
  private url = this.urlApi + 'v1/financeiro/';

  constructor(private http: HttpClient) {
    super();
  }

  // Inicio Conta
  getAllContas(): any {
    return this.http.get(this.url + 'conta/getAll')
      .catch(this.handleError);
  }

  get(id) {
    return this.http.get(this.url + 'conta/getById/' + id)
      .catch(this.handleError);
  }

  getContaByControleLancamento(id) {
    return this.http.get(this.url + 'conta/getByControleLancamento/' + id)
      .catch(this.handleError);
  }

  getByControleLancamento(id) {
    return this.http.get(this.url + 'conta/getSaldoByIdControle/' + id)
      .catch(this.handleError);
  }


  cadastrarEditar(conta) {
    const observable = (conta.idConta)
      ? this.http.put(this.url + 'conta/alterar', conta)
      : this.http.post(this.url + 'conta/cadastrar', conta);

    return observable.catch(this.handleError);
  }

  // Fim Conta

  getAllTipoForcecedores(): any {
    return this.http.get(this.url + 'tipoFornecedor/getAll')
      .catch(this.handleError);
  }

  getSaldosDetalhadoTipoFornecedor(id) {
    return this.http.get(this.url + 'tipoFornecedor/saldosDetalhado/' + id)
      .catch(this.handleError);
  }

  // Inicio Tipo Despesa

  cadastrarEditarTipoDespesa(tipoDespesa) {
    const observable = (tipoDespesa.idTipoDespesa)
      ? this.http.put(this.url + 'tipoDespesa/alterar', tipoDespesa)
      : this.http.post(this.url + 'tipoDespesa/cadastrar', tipoDespesa);

    return observable.catch(this.handleError);
  }

  getAllTipoDespesas(): any {
    return this.http.get(this.url + 'tipoDespesa/getAll')
      .catch(this.handleError);
  }

  getTipoDespesasByIdFornecedor(id): any {
    return this.http.get(this.url + 'tipoDespesa/getByIdFornecedor/' + id)
      .catch(this.handleError);
  }

  getByIdFornecedorUnidade(idUnidade, idTipoFornecedor, nomeDespesa): any {
    return this.http
      .post(
        this.url +
        'tipoDespesa/getByIdFornecedorUnidadeDespesa',
        {
          idUnidade,
          idTipoFornecedor,
          nomeDespesa
        }
      )
      .catch(this.handleError);
  }

  getAllByIdFornecedorUnidade(idUnidade, idTipoFornecedor): any {
    return this.http.get(this.url + 'tipoDespesa/getAllByIdFornecedorUnidadeDespesa/' + idUnidade + '/' + idTipoFornecedor)
      .catch(this.handleError);
  }
  // Fim Tipo despesa

  // Inicio Valor Despesa
  cadastrarEditarValorDespesa(valorDespesa) {
    const observable = (valorDespesa.idValorDespesa)
      ? this.http.put(this.url + 'valorDespesa/alterar', valorDespesa)
      : this.http.post(this.url + 'valorDespesa/cadastrar', valorDespesa);

    return observable.catch(this.handleError);
  }

  getAllValorDespesas(): any {
    return this.http.get(this.url + 'valorDespesa/getAll')
      .catch(this.handleError);
  }

  getByIdValorDespesas(id): any {
    return this.http.get(this.url + 'valorDespesa/getById/' + id)
      .catch(this.handleError);
  }
  // Fim Valor Despesa

  // Inicio Lancamento
  cadastrarEditarLancamento(lancamento) {
    const observable = (lancamento.idLancamento)
      ? this.http.put(this.url + 'lancamento/alterar', lancamento)
      : this.http.post(this.url + 'lancamento/cadastrar', lancamento);

    return observable.catch(this.handleError);
  }

  excluirLancamento(idLancamento,idUsuarioGestaoSS){
    return this.http.delete(this.url + 'lancamento/excluir/'+idLancamento+'/'+idUsuarioGestaoSS)
    .catch(this.handleError);
  }

  getAllLancamento(): any {
    return this.http.get(this.url + 'lancamento/getAll')
      .catch(this.handleError);
  }

  getByIdLancamento(id): any {
    return this.http.get(this.url + 'lancamento/getById/' + id)
      .catch(this.handleError);
  }

  getLancamentoSimplificado(id): any {
    return this.http.get(this.url + 'lancamento/getSimplificado/' + id)
      .catch(this.handleError);
  }

  getLancamentoByIdConta(id, idControleLancamento): any {
    return this.http.get(this.url + 'lancamento/getLancamentoByIdConta/' + id + '/' + idControleLancamento)
      .catch(this.handleError);
  }

  getDespesasCadastradasEdital(id, idControleLancamento): any {
    return this.http.get(this.url + 'lancamento/getDespesasCadastradasEdital/' + id + '/' + idControleLancamento)
      .catch(this.handleError);
  }

  getAllLancamentoDetalhado(): any {
    return this.http.get(this.url + 'lancamento/getLancamentoDetalhado')
      .catch(this.handleError);
  }

  getAllLancamentoDetalhadoByUnidade(id): any {
    return this.http.get(this.url + 'lancamento/getAllLancamentoDetalhadoByUnidade/' + id)
      .catch(this.handleError);
  }
  // Fim Lancamento

  // Inicio Controle Lançamento
  getAllControleLancamento(): any {
    return this.http.get(this.url + 'controleLancamento/getAll')
      .catch(this.handleError);
  }

  getByIdControleLancamento(id): any {
    return this.http.get(this.url + 'controleLancamento/get/' + id)
      .catch(this.handleError);
  }

  getHistorico(id): any {
    return this.http.get(this.url + 'controleLancamento/getHistorico/' + id)
      .catch(this.handleError);
  }

  getUnidadeByIdControle(id): any {
    return this.http.get(this.url + 'controleLancamento/GetUnidadeByIdControle/' + id)
      .catch(this.handleError);
  }


  alterarControleLancamento(controle) {
    return this.http.put(this.url + 'controleLancamento/alterar', controle);
  }
  // Fim Controle Lançamento

  excluirLancamentoCandidato(id) {
    return this.http.delete(this.url + 'lancamentoCandidato/deletar/' + id)
      .catch(this.handleError);
  }

  excluirLancamentoFornecedor(id) {
    return this.http.delete(this.url + 'lancamentoFornecedor/deletar/' + id)
      .catch(this.handleError);
  }

  excluirComprovanteDespesa(id) {
    return this.http.delete(this.url + 'lancamento/excluirComprovanteDespesa/' + id)
      .catch(this.handleError);
  }

  cadastrarHistoricoLancamento(lancamento) {
    return this.http.post(this.url + 'controleHistoricoLancamento/cadastrar', lancamento)
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/financeiro/financeiro.service.ts